import { formatCoupon } from '@epilot/journey-logic-commons'
import classNames from 'classnames'
import { useMemo } from 'react'
import type { ComponentProps } from 'react'
import { useTranslation } from 'react-i18next'

import { Icon, Typography, Spacing } from '../../../../../components'
import classes from '../../../styles/ProductCoupon.module.scss'
import { useTileContext } from '../../../utils/tile-context-utils'

type ProductCouponProps = {
  isStatic?: boolean
}

/**
 * Duplicated in block-renderers
 * @todo Consider sharing elsewhere
 */
const useProductTileCoupon = () => {
  const {
    config: { coupons },
    pricingDetails
  } = useTileContext()

  return useMemo(() => {
    const [firstItem] = pricingDetails.items ?? []

    /**
     * Coupon should only be displayed if it results in a discount OR cashback being applied
     * (note that in an initial phase composite prices don't get discounts applied)
     */
    if (
      (typeof firstItem?.discount_amount === 'number' &&
        firstItem?.discount_amount > 0) ||
      (typeof firstItem?.cashback_amount === 'number' &&
        firstItem?.cashback_amount > 0)
    ) {
      const [firstCoupon] = coupons

      return firstCoupon ?? null
    }

    return null
  }, [coupons, pricingDetails.items])
}

export const ProductCoupon = ({ isStatic }: ProductCouponProps) => {
  const { t } = useTranslation()
  const coupon = useProductTileCoupon()

  if (!coupon) return null

  return (
    <div
      className={classNames(
        'Concorde-ProductTile__Coupon',
        classes.couponContainer,
        coupon.category === 'cashback'
          ? classes.couponCashback
          : classes.couponDiscount,
        isStatic ? classes.couponNotPositioned : classes.couponPositioned
      )}
    >
      <Spacing alignItems="center" scale={2} variant="inline">
        {coupon.category === 'discount' && coupon.type === 'percentage' && (
          <Icon color="white" isFilled name="sell" size="16" />
        )}
        <Typography className={classes.discountText}>
          {formatCoupon(coupon, t)}
        </Typography>
      </Spacing>
    </div>
  )
}

export const ProductCouponWrapper = ({
  className,
  ...props
}: ComponentProps<'div'>) => (
  <div
    className={classNames(
      'Concorde-ProductTile__CouponWrapper',
      classes.container,
      className
    )}
    {...props}
  />
)
